"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KitRpcContext = void 0;
var kit_1 = require("@solana/kit");
var react_1 = require("react");
exports.KitRpcContext = (0, react_1.createContext)({
    rpc: (0, kit_1.createSolanaRpc)((0, kit_1.devnet)('https://api.devnet.solana.com')),
    rpcSubscriptions: (0, kit_1.createSolanaRpcSubscriptions)((0, kit_1.devnet)('wss://api.devnet.solana.com')),
});
